import React, { useEffect, useState } from 'react';
import Deli_Logo from '../assets/Deli_Logo.svg';
import Button from '../components/Button';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth0 } from '@auth0/auth0-react';
import { jwtDecode } from "jwt-decode";
import LoadingSpinner from '../components/LoadingSpinner';
import {updateUser, verifyCardOnFile} from '../utils/apiHandler';
import ValidationMessageBox from '../components/ValidationMessageBox';

const StepSpark = () => {
  const navigate = useNavigate();
  const [mlsNumber, setNumber] = useState(null);
  const { getAccessTokenSilently, getIdTokenClaims,isAuthenticated, isLoading, getAccessTokenWithPopup, logout} = useAuth0();
  const [displayValidationBox, setDisplayValidationBox] = useState(false);
  const [validationBoxHeader, setValidationBoxHeader] = useState('');
  const [validationBoxMessage, setValidationMesageBox] = useState('');
  const [errorValidationBox, setErrorValidationBox] = useState(false);
  const [btnLoading , setBtnLoading] = useState(false);
  const [isTokenChecked, setIsTokenChecked] = useState(false);

  useEffect(() => {
  
    const authenticate = async ()=>{

      await getAccessTokenSilently({cacheMode: 'off'});

      const idTokenClaims = await getIdTokenClaims();
      const idToken = idTokenClaims.__raw;
 
      if(idToken)
      {
        const decodedToken = jwtDecode(idToken);
        if (decodedToken?.mls_active) {
          if (decodedToken?.broker_mls_id){
            var paymentPlan = localStorage.getItem("plan_type") ? localStorage.getItem("plan_type") : 'monthly';
            if(await verifyCardOnFile(idToken, paymentPlan))
              navigate("/chat");
          }else{
            navigate("/step3");
          }
        }

        setTimeout(() => {
          setIsTokenChecked(true);
        }, 2000);
      }
    }

    authenticate()


  },[getIdTokenClaims, isAuthenticated,getAccessTokenSilently,navigate])
 

  if (!isTokenChecked || isLoading) {
    return <LoadingSpinner />; // Show the loading spinner when not authenticated and loading
  }


  const saveMlsId = async () => {
    let body = {
      mls_id: mlsNumber,
    }
    return await updateUser(getIdTokenClaims, body, false, getAccessTokenWithPopup, logout);
  }

  const NumberAuthentication = async () => {
    setBtnLoading(true);
    if (!mlsNumber) {
      toast.error("Please fill all fields");
      setBtnLoading(false);
      return;
    }
    const isSuccess = await saveMlsId();


    if (isSuccess) {
      setValidationBoxHeader("You're verified!");
      setValidationMesageBox('We have verified your membership');
      setErrorValidationBox(false);
      setDisplayValidationBox(true);
      setTimeout(async () => {
        let paymentPlan = localStorage.getItem("plan_type") ? localStorage.getItem("plan_type") : 'monthly';
        await getAccessTokenSilently({cacheMode: 'off'});

        if(await verifyCardOnFile((await getIdTokenClaims()).__raw, paymentPlan))
          navigate('/chat')
      }, 3000);

    } else {
      setValidationBoxHeader("Cannot be verified");
      setValidationMesageBox('Your MLS ID cannot be verified. if you think this is incorrect, contact support');
      setErrorValidationBox(true);
      setDisplayValidationBox(true);
      setBtnLoading(false);
    }
  };

  return (
    <div className="bg-gradient-custom flex flex-col items-center w-full h-[100vh] pt-14">
        <div className="flex justify-center items-center">
          <img src={Deli_Logo} alt="" />
        </div>

        <div className="mt-8 lg:mt-24 w-full lg:w-[40%]">
          <div className="max-w-full px-5 lg:mb-8 mx-auto flex items-center justify-center flex-col">
            <h1 className="text-black font-semibold text-4xl leading-tight text-center">
              MLS ID
            </h1>
            <p className="text-[#344054] text-md">
              Please enter your MLS ID
            </p>
          </div>
          <div className="max-w-full px-4 mx-auto mt-4">
            <div className="mb-4 lg:mb-6">
              <input
                onChange={(e) => setNumber(e.target.value)}
                className="w-full py-3 px-4 rounded-full border-[#D0D5DD] border bg-[#FCFCFC] focus:outline-[#B0B5BD]"
                type="text"
                placeholder="Enter MLS ID"
              />
            </div>
            {displayValidationBox && (
              <div className="mb-4 lg:mb-6">
                <ValidationMessageBox success={!errorValidationBox} description={validationBoxMessage} heading={validationBoxHeader}/>
              </div>
            )}
            <Button
             text={btnLoading ? "Loading ..." : "Apply"}
             bgColor={btnLoading ? "bg-[#9199a7]" : "bg-[#0062ff]"}
             textColor="text-white"
             disabled={btnLoading}
             onClick={NumberAuthentication}
            />
          </div>
        </div>
    </div>
  );
};

export default StepSpark;
